export function PageHero({ label, title, subtitle, children }) {
  return (
    <div className="relative overflow-hidden rounded-xl border border-white/10 bg-white/[0.04] backdrop-blur-xl shadow-[0_24px_60px_-40px_rgba(0,0,0,0.9)] animate-fade-up">
      <span className="absolute inset-x-0 top-0 h-[3px] bg-gradient-to-r from-cyan-400 via-indigo-500 to-transparent" />
      <span className="pointer-events-none absolute -top-20 left-1/4 h-48 w-80 rounded-full bg-blue-500/20 blur-3xl" />
      <div className="relative flex flex-col md:flex-row md:items-center md:justify-between gap-4 p-5 sm:p-6 md:p-7">
        <div>
          {label && <span className="label-caps">{label}</span>}
          <h1 className="font-display text-xl sm:text-2xl md:text-3xl font-extrabold tracking-tight mt-1.5 text-slate-900">{title}</h1>
          {subtitle && <p className="text-sm text-slate-500 mt-1.5 max-w-2xl leading-relaxed">{subtitle}</p>}
        </div>
        {children && <div className="flex flex-wrap items-center gap-2 shrink-0">{children}</div>}
      </div>
    </div>
  );
}
